module.exports = __webpack_public_path__ + "static/img/TT_logo@3x.9f1cd52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/TT-tiny-img/TT_logo@3x.png
// module id = chyW
// module chunks = 1